import React from 'react';
import { Zap, Moon, Target, Waves } from 'lucide-react';

const SessionModeSelector = ({ selectedMode, onModeSelect, compact = false }) => {
  const modes = [
    {
      id: 'flow',
      name: 'Flow',
      description: 'Balanced state for learning',
      icon: Waves,
      color: 'from-indigo-500 to-purple-500',
      bgColor: 'bg-indigo-500/20',
      borderColor: 'border-indigo-500/50'
    },
    {
      id: 'deep_rewire',
      name: 'Deep Rewire',
      description: 'Subconscious reprogramming',
      icon: Target,
      color: 'from-violet-500 to-purple-600',
      bgColor: 'bg-violet-500/20',
      borderColor: 'border-violet-500/50'
    },
    {
      id: 'performance',
      name: 'Performance',
      description: 'High energy activation',
      icon: Zap,
      color: 'from-amber-500 to-orange-500',
      bgColor: 'bg-amber-500/20',
      borderColor: 'border-amber-500/50'
    },
    {
      id: 'sleep',
      name: 'Sleep',
      description: 'Gentle wind down',
      icon: Moon,
      color: 'from-blue-500 to-cyan-500',
      bgColor: 'bg-blue-500/20',
      borderColor: 'border-blue-500/50'
    }
  ];

  if (compact) {
    return (
      <div className="flex gap-2">
        {modes.map(mode => {
          const Icon = mode.icon;
          const isSelected = selectedMode === mode.id;
          
          return (
            <button
              key={mode.id}
              onClick={() => onModeSelect(mode.id)}
              className={`flex-1 p-3 rounded-xl border transition-all ${
                isSelected 
                  ? `${mode.bgColor} ${mode.borderColor}` 
                  : 'bg-white/5 border-white/10 hover:bg-white/10'
              }`}
              data-testid={`mode-${mode.id}-btn`}
            >
              <Icon className={`w-5 h-5 mx-auto mb-1 ${
                isSelected ? 'text-white' : 'text-slate-400'
              }`} />
              <p className={`text-xs text-center ${
                isSelected ? 'text-white' : 'text-slate-400'
              }`}>
                {mode.name}
              </p>
            </button>
          );
        })}
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {modes.map(mode => {
        const Icon = mode.icon;
        const isSelected = selectedMode === mode.id;
        
        return (
          <button
            key={mode.id}
            onClick={() => onModeSelect(mode.id)}
            className={`w-full p-4 rounded-xl border transition-all text-left flex items-center gap-4 ${
              isSelected 
                ? `${mode.bgColor} ${mode.borderColor}` 
                : 'bg-white/5 border-white/10 hover:bg-white/10'
            }`}
            data-testid={`mode-${mode.id}-btn`}
          >
            <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${mode.color} 
                          flex items-center justify-center`}>
              <Icon className="w-6 h-6 text-white" />
            </div>
            <div className="flex-1">
              <p className="font-medium text-white">{mode.name}</p>
              <p className="text-sm text-slate-400">{mode.description}</p>
            </div>
            {isSelected && (
              <div className="w-3 h-3 rounded-full bg-white" />
            )}
          </button>
        );
      })}
    </div>
  );
};

export default SessionModeSelector;
